import React from 'react';
import Swipeable from 'react-swipeable';
import './TourButtonsDrawer.scss';

const TourButtonsDrawer = ({ normal, show, close, buttons }) => {
  return (
    <div id="tour-btns-drawer" className={show ? 'drawer-wrapper open' : 'drawer-wrapper'}>
      <Swipeable
        onSwipedRight={close}
        className="tour-btns-drawer"
        style={{ backgroundColor: normal.background, color: normal.text }}
      >
        <div className="tour-btns-drawer__btns-wrapper">{buttons}</div>
      </Swipeable>
    </div>
  );
};

export default TourButtonsDrawer;
